import { UpgradeOffer } from 'src/types/upgradeOffer';

export function failureResponse(
  error: string,
  statusCode?: number,
  errorCode?: string | number,
  upgradeOffer?: UpgradeOffer,
) {
  return {
    success: false,
    message: error,
    statusCode,
    errorCode,
    upgradeOffer,
  };
}
